import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlanning: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPlanning"><Path d="M3.5 7.75L5.25 9.5L8.5 5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 7.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 16.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 18.5C6.60457 18.5 7.5 17.6046 7.5 16.5C7.5 15.3954 6.60457 14.5 5.5 14.5C4.39543 14.5 3.5 15.3954 3.5 16.5C3.5 17.6046 4.39543 18.5 5.5 18.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPlanning;
